import React from 'react';
import { Sparkles } from 'lucide-react';
export function SparkleDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-4 py-8 ${className}`} data-id="element-249">
      <div className="h-px w-16 bg-gradient-to-r from-transparent to-brand-gold/30" data-id="element-250" />
      <Sparkles className="w-5 h-5 text-brand-gold" data-id="element-251" />
      <div className="h-px w-16 bg-gradient-to-l from-transparent to-brand-gold/30" data-id="element-252" />
    </div>;
}